import { render } from "./message-input-at.vue?vue&type=template&id=50a44881&scoped=true&ts=true"
import script from "./message-input-at.vue?vue&type=script&lang=ts"
export * from "./message-input-at.vue?vue&type=script&lang=ts"

import "./message-input-at.vue?vue&type=style&index=0&id=50a44881&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a44881"]])

export default __exports__